// Pin one request to one branch (spec P1). The axios interceptor
// (utils/requestHeaders applyRequestHeaders) sees __singleBranch and does
// not add x-garage-scope, so the backend treats the call as single-branch
// even when the header picker is on "All branches".
export function withBranch(garageId, config = {}) {
  if (!garageId) return config;
  return {
    ...config,
    __singleBranch: true,
    headers: { ...config.headers, 'x-garage-id': garageId },
  };
}

// Fail closed (security review: the branch list can be loading, failed, or
// cleared by a token change — multiBranch alone must never decide whether a
// create is pinned). Pin whenever the chosen branch differs from the header,
// or the header is on "All branches", or the user has more than one branch.
// A one-branch user whose selected branch IS the header gets [], so the call
// keeps today's exact base shape (no extra config argument).
export function branchArgs(gid, { multiBranch } = {}) {
  if (!gid) return [];
  const header = localStorage.getItem('activeGarageId') || '';
  return multiBranch || header === 'all' || String(gid) !== String(header)
    ? [withBranch(gid)]
    : [];
}

// Same rule for a call that always takes a config object (GETs with params):
// base config when the call stays unpinned, the base pinned to the branch
// when it does not.
export function branchConfig(gid, base = {}, opts) {
  return branchArgs(gid, opts).length ? withBranch(gid, base) : base;
}
